import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Union"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 5.25V0.25H8V5.25H0ZM11 6.75H19V11.75H11V6.75ZM19 13.75H11V18.75H19V13.75ZM2.99995 6.25V17.25H3V17.25H10V15.55H4.69995V10.25H10V8.55005H4.69995V6.25H2.99995Z"
      fill="#222A5C"
    />
  </svg>,
  "SubaccountsFilled"
);
